import { render } from "./SelectChanelTrigger.vue?vue&type=template&id=b6b17c76&scoped=true&ts=true"
import script from "./SelectChanelTrigger.vue?vue&type=script&lang=ts"
export * from "./SelectChanelTrigger.vue?vue&type=script&lang=ts"

import "./SelectChanelTrigger.vue?vue&type=style&index=0&id=b6b17c76&lang=scss&scoped=true"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b17c76"]])

export default __exports__